import React from 'react'
import Home from "./components/home";
const index = () => {
  return (
    <div>
        <Home  />
    </div>
  )
}

export default index